// extracted by mini-css-extract-plugin
module.exports = {"footer":"footer-module--footer--3YcZG","columnContainer":"footer-module--column-container--3TGL1","imageLink":"footer-module--image-link--w2Ale"};